/* eslint-disable max-len */
/* eslint-disable react/no-unknown-property */
import React from 'react';
import PropTypes from 'prop-types';
import noop from 'lodash/noop';
import styled from 'styled-components';

export const CloseIconWrapper = styled.div`
  cursor: pointer;
  background: #3E7697;
  display: flex;
  justify-content: center;
  align-items: center;
  padding-right: 10px;
  @media all and (max-width: 768px) {
    padding: 3px 3px 0 0;
  }
`;

const Close = ({ onClick }) => (
  <CloseIconWrapper onClick={onClick}>
    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink" width="20" height="20" viewBox="0 0 32 32">
      <g fill="rgb(62, 118, 151)" />
      <path d="M27.229 8.391l-3.385-3.386-7.843 7.838-7.84-7.84-3.386 3.385 7.609 7.608-7.613 7.612 3.385 3.386 7.843-7.838 7.84 7.841 3.387-3.386-7.61-7.608z" fill="white" />
    </svg>
  </CloseIconWrapper>
);

Close.propTypes = {
  onClick: PropTypes.func,
};

Close.defaultProps = {
  onClick: noop,
};

export default Close;